import { createStandardAction } from 'typesafe-actions'

import { ThunkResult } from './types'
import { getAuthState, parseJwt, getAllocationMap, getSubscriptionStatus } from '../util/helpers'
import isProduction from '../standalone/isProduction'
import { initializeWtaClient } from '../analytics/wtaAnalytics'
import { PAGE_TYPE } from '../analytics/constants'
import { BUSINESS_UNIT } from '../types'
import { productMap } from '../analytics/helpers'
import { getJwt } from '../util/jwtLocalstorage'
import { googleApiInitialized } from './dependencies'
import { getKeys, pusherConnected, pusherDisconnected } from './pusher'
import { setTraceId } from './upload'
import { clearJwt, clearLegacyCookie } from '../util/jwtLocalstorage'
import wfeTokenRefresh from '../util/wfeTokenRefresh'

export const ActionTypes = {
  PAGE_VIEW: 'PAGE_VIEW',
  APP_INITIALIZING: 'APP_INITIALIZING',
  APP_INITIALIZED: 'APP_INITIALIZED',
}

export const pageView = createStandardAction(ActionTypes.PAGE_VIEW)()

export const initializeAnalytics = () => {
  const token = getJwt()

  if (token) {
    const parsedToken = parseJwt(token)
    const { cheggUserUuid, site, paidMember } = parsedToken

    initializeWtaClient({
      pageType: PAGE_TYPE,
      subscriptionStatus: getSubscriptionStatus(paidMember),
      authState: getAuthState(cheggUserUuid),
      cheggUuid: cheggUserUuid || undefined,
      staging: !isProduction(),
      property: site,
      appId: 'wfe',
      testCells: getAllocationMap(),
      product: productMap[site],
      businessUnit: BUSINESS_UNIT,
    })
  }
}

export const initializeConfiguration: ThunkResult<void> = async (
  dispatch,
  getState,
  { config, gapi, pusherClient }
) => {
  const { site, app: { upload, pasteOnly, initRSW, initFreshToken } } = getState()

  dispatch({ type: ActionTypes.APP_INITIALIZING })

  config.init({
    upload,
  })
  config.setSite(site)
  clearLegacyCookie()
  try {
    if (!pasteOnly) {
      await gapi.init()
      await gapi.onApiLoad()
      dispatch(googleApiInitialized())
    }

    if (initFreshToken) {
      clearJwt()
      await wfeTokenRefresh()
    }
  } catch (e) {
    console.error(e)
    // TODO -> error handling?
  }
  try {
    const keys = await getKeys()

    if (!keys) {
      throw new Error('could not fetch keys')
    }
    await pusherClient.initialize(
      keys.appKey,
      keys.cluster,
      () =>
        dispatch(
          pusherConnected({
            appKey: keys.appKey,
            channelName: keys.channelName,
            cluster: keys.cluster,
          })
        ),
      () => dispatch(pusherDisconnected())
    )

    dispatch(
      setTraceId({
        traceId: keys.traceId,
      })
    )

    dispatch({
      type: ActionTypes.APP_INITIALIZED,
      config: {
        debug: config.debug,
        environment: config.environment,
        upload,
        site,
      },
    })
    dispatch(pageView())

    if (initRSW) {
      initializeAnalytics()
    }
  } catch (e) {
    console.error(e)
  }
}
